import { lazy } from 'react'

import AddLiquidity from '../AddLiquidity'
import { RedirectDuplicateTokenIds } from '../AddLiquidity/redirects'
import { RedirectDuplicateTokenIdsV2 } from '../AddLiquidityV2/redirects'
import FeesStats from '../FeesStats'
import MigrateV2 from '../MigrateV2'
import MigrateV2Pair from '../MigrateV2/MigrateV2Pair'
import Pool from '../Pool'
import PositionPage from '../Pool/PositionPage'
import PoolFinder from '../PoolFinder'
import RemoveLiquidity from '../RemoveLiquidity'
import RemoveLiquidityV3 from '../RemoveLiquidity/V3'
import { RouteConfig } from './types'

const TokenDetails = lazy(() => import('../TokenDetails'))

export const privateRoutes: RouteConfig[] = [
  {
    path: 'tokens/:chainName/:tokenAddress',
    element: TokenDetails,
  },
  {
    path: 'pool/v2/find',
    element: PoolFinder,
  },
  {
    path: 'pool',
    element: Pool,
  },
  {
    path: 'pool/:tokenId',
    element: PositionPage,
  },
  {
    path: 'pools/v2/find',
    element: PoolFinder,
  },
  {
    path: 'pools',
    element: Pool,
  },
  {
    path: 'pools/:tokenId',
    element: PositionPage,
  },
  {
    path: 'add/v2',
    element: RedirectDuplicateTokenIdsV2,
    children: [
      {
        path: ':currencyIdA',
      },
      {
        path: ':currencyIdA/:currencyIdB',
      },
    ],
  },
  {
    path: 'add',
    element: RedirectDuplicateTokenIds,
    children: [
      {
        path: ':currencyIdA',
      },
      {
        path: ':currencyIdA/:currencyIdB',
      },
      {
        path: ':currencyIdA/:currencyIdB/:feeAmount',
      },
    ],
  },
  {
    path: 'increase',
    element: AddLiquidity,
    children: [
      {
        path: ':currencyIdA',
      },
      {
        path: ':currencyIdA/:currencyIdB',
      },
      {
        path: ':currencyIdA/:currencyIdB/:feeAmount',
      },
      {
        path: ':currencyIdA/:currencyIdB/:feeAmount/:tokenId',
      },
    ],
  },
  {
    path: 'remove/v2/:currencyIdA/:currencyIdB',
    element: RemoveLiquidity,
  },
  {
    path: 'remove/:tokenId',
    element: RemoveLiquidityV3,
  },
  {
    path: 'migrate/v2',
    element: MigrateV2,
  },
  {
    path: 'migrate/v2/:address',
    element: MigrateV2Pair,
  },
  {
    path: 'fees-stats',
    element: FeesStats,
  },
]
